class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      // TRWS (2026-11-03): the custom header has no #cart-icon-bubble. Without this check the
      // update threw here and the header cart count never refreshed until a page reload.
      const target = document.getElementById(section.id);
      const html = parsedState.sections && parsedState.sections[section.id];
      if (!target || !html) return;
      try {
        target.innerHTML = this.getSectionInnerHTML(html, section.selector);
      } catch (e) {
        console.error(e);
      }
    });

    CartNotification.refreshHeaderCount();

    if (this.header) this.header.reveal();
    this.open();
  }

  // TRWS: update the custom header's cart link (a.cart-button), which shows "(n)" after the icon.
  static refreshHeaderCount(count) {
    const apply = (n) => {
      document.querySelectorAll('a.cart-button').forEach((link) => {
        Array.from(link.childNodes).forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE || (node.nodeType === Node.ELEMENT_NODE && node.dataset.trwsCartCount !== undefined)) node.remove();
        });
        if (n > 0) {
          const span = document.createElement('span');
          span.dataset.trwsCartCount = '';
          span.textContent = ` (${n})`;
          link.appendChild(span);
        }
        link.setAttribute('aria-label', n > 0 ? `Cart, ${n} item${n === 1 ? '' : 's'}` : 'Cart');
      });
    };
    if (typeof count === 'number') return apply(count);
    fetch(`${(window.routes && window.routes.cart_url) || '/cart'}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => apply(cart.item_count))
      .catch((e) => console.error(e));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

// TRWS: keep the header count right after any cart change (quick add, cart page edits, apps).
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    const count = event && event.cartData && typeof event.cartData.item_count === 'number' ? event.cartData.item_count : undefined;
    CartNotification.refreshHeaderCount(count);
  });
}
